export default function filterReportsIfExistsInPostalOperator(
  reportsCodes,
  postalOperators,
) {
  const result = [];

  if (!postalOperators || postalOperators.length === 0) {
    return [...reportsCodes];
  }

  const addIfExists = (reportCode) => {
    if (reportsCodes.includes(reportCode)) {
      result.push(reportCode);
    }
  };

  // eslint-disable-next-line no-plusplus
  for (let index = 0; index < postalOperators.length; index++) {
    const postalOperator = postalOperators[index];
    addIfExists(postalOperator.value);
  }

  return result;
}
